import { render, staticRenderFns } from "./DaftarBatch.vue?vue&type=template&id=20533d98"
import script from "./DaftarBatch.vue?vue&type=script&lang=js"
export * from "./DaftarBatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports